






























































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import { DocConsenso } from "../../_models/docConsenso";

@Component
export default class ConsensoSign extends Vue {
  @Prop() docInfo!: DocConsenso;
  @Prop() soggetto!: string;
  private firmaAzienda: string;

  private tipoAttivita: string;

  constructor() {
    super();
    this.firmaAzienda = "";
    this.tipoAttivita = ""
  }

//   clearEnterpriseSignature() {
//     //@ts-ignore
//     this.$refs.enterpriseSignaturePad.clearSignature();
//   }

//   clearStudentSignature() {
//     //@ts-ignore
//     this.$refs.studentSignaturePad.clearSignature();
//   }
  clearEnterpriseDueSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignatureDuePad.clearSignature();
  }

  clearStudentDueSignature() {
    //@ts-ignore
    this.$refs.studentSignatureDuePad.clearSignature();
  }

  close() {
    bus.$emit("closeDocSignDialog");
  }

  save() {
    var signatureAziendaEmpty: boolean = true;
    var signatureAllievoEmpty: boolean = true;
    if (this.soggetto === "azienda") {
      //@ts-ignore
    //   const signatureAzienda = this.$refs.enterpriseSignaturePad.saveSignature();
      //@ts-ignore
      const signatureAziendaDue = this.$refs.enterpriseSignatureDuePad.saveSignature();
      if (signatureAziendaDue.isEmpty === false) {
        const payload = {
          idConsenso: this.docInfo.idConsenso,
          firma: signatureAziendaDue.data,
          soggetto: this.soggetto
        };
        user
          .dispatchSignConsenso(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Dichiarazione di Consenso Firmato con successo"
            );
            bus.$emit("loadProgettoOrientamento");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      } else {
        bus.$emit("errorOperation", "Firma Legale Rappresentante mancante");
      }
    } else {
      //@ts-ignore
    //   const signatureAllievo = this.$refs.studentSignaturePad.saveSignature();
      //@ts-ignore
      const signatureAllievoDue = this.$refs.studentSignatureDuePad.saveSignature();
      if (signatureAllievoDue.isEmpty === false) {
        const payload = {
          idConsenso: this.docInfo.idConsenso,
          firma: signatureAllievoDue.data,
          soggetto: this.soggetto
        };
        user
          .dispatchSignConsenso(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Dichiarazione di Consenso Firmato con successo"
            );
            bus.$emit("loadProgettoOrientamento");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      } else {
        bus.$emit("errorOperation", "Firma Tirocinante mancante");
      }
    }
  }
  created(){
    if(this.docInfo.tipoAttivita === "tirocinioReIns"){
      this.tipoAttivita = "tirocinio di inserimento/reinserimento"
    }else if(this.docInfo.tipoAttivita === "tirocinioFormativo"){
      this.tipoAttivita = "tirocinio formativo e di orientamento"
    }
  }
}
